import React from "react";
import "../../Components/Menu/Menu.css";

export default function Change() {
  return (
    <div>
      <h4 className="sub-title">Endringer i brukervilkår</h4>
      <p className="content">
        Bilista tar forbehold om at det vil kunne skje endringer i appen og
        brukervilkårene i fremtiden. Ved mindre endringer vil vi normalt
        informere om dette direkte i appen. Gjennomfører vi vesentlige
        endringer, vil du motta varsel direkte gjennom tilgjengelige kanaler,
        for eksempel gjennom appen eller e-post.
      </p>
    </div>
  );
}
